import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import * as React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import { schemaFormEventValidate } from "../../../features/forms/schemas/schemaFormEventValidate";
import { isDev } from "../../../utils/dev";
import FieldRadioButton from "../fields/FieldRadioButton";
import FieldTextArea from "../fields/FieldTextArea";

export const formNameEventValidate = "form-event-validate";

export type FormEventValidateSchema = z.infer<typeof schemaFormEventValidate>;

type Props = {
  onSubmit: SubmitHandler<FormEventValidateSchema>;
};

const validateOrRefuseOptions = [
  {
    label: "Valider",
    value: "validate",
  },
  {
    label: "Refuser",
    value: "refused",
  },
];

const FormEventValidate: React.FC<Props> = ({ onSubmit }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormEventValidateSchema>({
    defaultValues: {
      validateOrRefuse: "validate",
    },
    resolver: zodResolver(schemaFormEventValidate),
  });

  if (isDev) {
    const formValues = watch(); // Get the form values state
    console.log("formValues", formValues);
    console.log("errors", errors);
  }

  return (
    <Form
      id={formNameEventValidate}
      onFinish={handleSubmit(onSubmit)}
      labelCol={{ span: 4 }}
    >
      <FieldRadioButton<FormEventValidateSchema>
        errorMessage={errors?.validateOrRefuse?.message}
        control={control}
        name="validateOrRefuse"
        options={validateOrRefuseOptions}
      />
      <FieldTextArea<FormEventValidateSchema>
        errorMessage={errors?.comment?.message}
        control={control}
        name="comment"
        label="Commentaire"
        placeholder="Commentaire..."
        isVertical
      />
    </Form>
  );
};

export default FormEventValidate;
